import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainServices from "../../../../services/MainServices";
import axios from "axios";
import useCurrentPage from "../../../../hooks/useCurrentPage";
import PageLoader from "../../../../assets/loaders/PageLoading";
import { backarrowicon } from "../../../../assets/images/icons/icons";
import editIcon from "../../../../assets/images/icons/edit.svg";

export default function WorkflowGroupDetails() {
  const location = useLocation();
  const publicId = new URLSearchParams(location.search).get("publicId");
  const [pageLoading, setPageLoading] = useState(false);
  const { updateCurrentPage } = useCurrentPage();
  const { getWorkflowGroupById } = MainServices();
  const navigate = useNavigate();
  const [selectedIDCMatrix, setSelectedIDCMatrix] = useState();

  useEffect(() => {
    updateCurrentPage({
      title: "WorkFlow Group",
      subtitle: "",
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getIDCMastersById();
  }, [publicId]);

  const getIDCMastersById = async () => {
    setPageLoading(true);
    const details = {};
    await axios
      .all([getWorkflowGroupById(details, publicId)])
      .then(function (res) {
        if (res[0]) {
          let resData = res[0];
          if (resData.success) {
            let IDCMasters = resData.data ? resData.data : {};
            setSelectedIDCMatrix(IDCMasters);
            setPageLoading(false);
          } else {
            setPageLoading(false);
          }
        } else {
          setPageLoading(false);
        }
      })
      .catch(function (res) {
        console.log(res);
        if (res.message)
          console.log("An error occurred in getting Workflow Group");
      });
  };

  return (
    <div className="training-sop-main">
      <div className="admin-popular-main lims-details-page tms-inventory-details-page">
        {pageLoading ? (
          <PageLoader />
        ) : (
          <>
            <div className="details-page-toolbar">
              <div className="details-page-toolbar__left">
                <button
                  type="button"
                  className="btn btn-link details-page-back-btn"
                  onClick={() => navigate(-1)}
                  title="Back"
                  aria-label="Go back"
                >
                  {backarrowicon}
                </button>
                <div className="details-page-title-block">
                  <p className="content-header-main mb-0">WorkFlow Group Details</p>
                </div>
              </div>
              {selectedIDCMatrix && (
                <div className="details-page-toolbar__right">
                  <button
                    className="details-page-action-btn theme-btn-main btn"
                    onClick={() =>
                      navigate({
                        pathname: "/workflow-group/add-workflow-group",
                        search: `publicId=${selectedIDCMatrix?.publicId}`,
                      })
                    }
                  >
                    <img src={editIcon} alt="edit" style={{ width: 16, marginRight: 6 }} />
                    Edit
                  </button>
                </div>
              )}
            </div>

            {selectedIDCMatrix ? (
              <div className="details-page-content">
                <div className="details-card mb-0">
                  <div className="details-card__header">
                    <h2 className="details-card__title">Workflow Group Information</h2>
                  </div>
                  <div className="details-grid">
                    <div className="details-grid__item">
                      <span className="details-grid__label">WorkFlow Group Name</span>
                      <span className="details-grid__value">
                        {selectedIDCMatrix.workflowGroupName || "-"}
                      </span>
                    </div>
                  </div>
                </div>

                {selectedIDCMatrix?.workflowData && selectedIDCMatrix?.workflowData.length > 0 &&
                  selectedIDCMatrix.workflowData.map((data, index) => (
                    <div key={index} className="details-section-card mt-4">
                      <div className="details-section-card__header">
                        <h3
                          className="lims-details-inner-subheading"
                          style={{ textTransform: "capitalize" }}
                        >
                          {data?.workflow}
                        </h3>
                      </div>
                      {data?.users && data?.users.length > 0 && (
                        <div className="details-table-wrap mt-3">
                          <table className="details-table">
                            <thead>
                              <tr>
                                <th>S.No.</th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Department</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.users.map((each, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{each.label}</td>
                                  <td>{each?.designation?.desgName || "-"}</td>
                                  <td>{each?.deptartment?.deptName || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            ) : (
              <div className="no-data-found-main">No WorkFlow Found</div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
